invHdApp.
  factory('Supplier', ['$http', function ($http) {
    return {
      init: function (data) {
        return $http.post('api/suppliers', data);
      },
      newCustomer: function () {
        return $http.get('api/new-supplier');
      },
      sendNote: function (data) {
        return $http.post('api/send-supplier-note', data);
      },
      show: function (e) {
        return $http.get('api/supplier/' + e);
      },
      saveCustomer: function (data) {
        return $http.post('api/save-supplier', data);
      },
      deleteCustomer: function (data) {
        return $http.post('api/delete-supplier', data);
      },
      updateCustomer: function (data) {
        return $http.post('api/update-supplier', data);
      },
      changeSupplierStatus: function (data) {
        return $http.post('api/change-supplier-status', data);
      },
    };
  }]);